export class News {
  id: string = ""
  date: string = ""
  text: string = ""
  
  constructor(args?: Partial<News>) {
    for (const argument in args) {
      this[argument] = args[argument]
    }
  }
}
